const INC_PX = 96

export function remFactory(useRem, baseSize) {
  return {
    getRemFromPt(pt) {
      if (typeof pt === 'string') {
        return pt
      }
      const px = pt * INC_PX / 72
      const rem = px / baseSize

      return `${rem.toFixed(3)}rem`
    },
    getLength(length) {
      if (typeof length === 'string') {
        return length
      }
      if (!useRem) {
        return `${length}px`
      }
      const rem = length / baseSize

      return `${rem.toFixed(3)}rem`
    },
  }
}
